import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tableView', 'kanbanView', 'tableBtn', 'kanbanBtn']


  connect () {
    // Восстанавливаем сохранённый вид из localStorage
    const savedView = localStorage.getItem('reservations_view') || 'table'
    if (savedView === 'kanban') {
      this.showKanban()
    } else {
      this.showTable()
    }
  }

  showTable () {
    this.tableViewTarget.style.display = 'block'
    this.kanbanViewTarget.style.display = 'none'

    this.tableBtnTarget.classList.add('admin-reservations__view-btn--active')
    this.kanbanBtnTarget.classList.remove('admin-reservations__view-btn--active')

    localStorage.setItem('reservations_view', 'table')
  }

  showKanban () {
    this.tableViewTarget.style.display = 'none'
    this.kanbanViewTarget.style.display = 'block'

    this.kanbanBtnTarget.classList.add('admin-reservations__view-btn--active')
    this.tableBtnTarget.classList.remove('admin-reservations__view-btn--active')

    localStorage.setItem('reservations_view', 'kanban')
  }
}
